const React = require('react')
const PropTypes = require('prop-types')

class CssStyleRenderer extends React.Component {
    static displayName = 'CssStyleRenderer'
    static compType = 'CssStyleRenderer'
    static propTypes = {
        cssString: PropTypes.string.isRequired
    }

    render() {
        const {cssString} = this.props
        return (
            <style type='text/css'
                dangerouslySetInnerHTML={{__html: cssString}}/>
        )
    }
}

module.exports = CssStyleRenderer